"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
(function () {
  var _React = React,
    useState = _React.useState,
    useEffect = _React.useEffect,
    useRef = _React.useRef,
    useContext = _React.useContext,
    createContext = _React.createContext;

  // =========================================================================================
  // PATIENT SCREENS, NUMBERED AND CHOSEN FROM THE CONTROLLER (window.SimScreens has the roles).
  //
  // A patient screen joins with the session code and nothing else. It announces itself in
  // sessions/<CODE>/presence/<its id> (role "screen:<what it shows now>"), and the CONTROLLER is
  // the only writer of sessions/<CODE>/screens/<id> = { n, role, ts }: it gives every new screen
  // the lowest free number and "Everything", and changes the role whenever the facilitator picks
  // something else. While a Screens panel is open on the controller, sessions/<CODE>/
  // screenIdentify is true and every screen shows its big number (like Windows' Identify); it is
  // removed when the panel closes, or if the controller goes away.
  // =========================================================================================
  var ScreenLinkContext = createContext(null);
  var RECENT_MS = 10 * 60 * 1000; // a screen that dropped out stays listed (greyed) this long
  var STALE_MS = 30000; // no heartbeat for this long (local clock) = not connected

  var useScreenLinkController = function useScreenLinkController(sessionID, enabled) {
    var S = window.SimScreens;
    var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      presence = _useState2[0],
      setPresence = _useState2[1];
    var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      assigns = _useState4[0],
      setAssigns = _useState4[1];
    // Nothing is numbered until the existing numbers have been read: otherwise a controller that
    // reloads would renumber every screen (and reset what it shows) from an empty list.
    var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      assignsLoaded = _useState6[0],
      setAssignsLoaded = _useState6[1];
    var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      setTick = _useState8[1];
    var beats = useRef({}); // id -> { ts, at }: when THIS computer last saw its heartbeat change
    var firstSeen = useRef({}); // id -> when this controller first saw it connected
    var lastSeen = useRef({}); // id -> when this controller last saw it connected
    var pending = useRef({}); // numbering writes not yet echoed back
    var identifyRef = useRef(false); // a Screens panel is open (numbers wanted on the screens)
    var codeRef = useRef(sessionID);
    codeRef.current = sessionID;
    var db = window.db;
    var on = !!(enabled && db && sessionID);
    useEffect(function () {
      if (!on) return;
      var pRef = db.ref("sessions/".concat(sessionID, "/presence"));
      var sRef = db.ref("sessions/".concat(sessionID, "/screens"));
      var onP = function onP(snap) {
        var v = snap.val() || {};
        var now = Date.now();
        Object.keys(v).forEach(function (id) {
          var ts = Number((v[id] || {}).ts) || 0;
          var b = beats.current[id];
          // A row seen for the first time counts as live only if its heartbeat is recent
          // (2 minutes allows for a tablet's clock being a little out). A leftover row from
          // a tab that froze or never ran its onDisconnect must not be numbered as a
          // connected screen; if it is really alive, its next heartbeat makes it live.
          if (!b) beats.current[id] = {
            ts: ts,
            at: Math.abs(now - ts) < 120000 ? now : 0
          };else if (b.ts !== ts) beats.current[id] = {
            ts: ts,
            at: now
          };
        });
        setPresence(v);
      };
      var onS = function onS(snap) {
        pending.current = {};
        setAssigns(snap.val() || {});
        setAssignsLoaded(true);
      };
      var onErr = function onErr(e) {
        return console.warn('Screens read failed', e);
      };
      pRef.on('value', onP, onErr);
      sRef.on('value', onS, onErr);
      var t = setInterval(function () {
        return setTick(function (x) {
          return x + 1;
        });
      }, 5000);
      // onDisconnect() is one-shot: after a network blip on the controller the server has
      // already removed screenIdentify, so put it back (and re-arm) while a panel is open.
      var connRef = db.ref('.info/connected');
      var onConn = function onConn(snap) {
        if (snap.val() === true && identifyRef.current) showNumbers(true);
      };
      connRef.on('value', onConn);
      return function () {
        pRef.off('value', onP);
        sRef.off('value', onS);
        clearInterval(t);
        connRef.off('value', onConn);
        beats.current = {};
        firstSeen.current = {};
        lastSeen.current = {};
        pending.current = {};
        setPresence({});
        setAssigns({});
        setAssignsLoaded(false);
        try {
          db.ref("sessions/".concat(sessionID, "/screenIdentify")).remove()["catch"](function () {});
        } catch (e) {}
      };
    }, [on, sessionID]);
    var now = Date.now();
    var live = function live(id) {
      return !!(presence[id] && beats.current[id] && now - beats.current[id].at < STALE_MS);
    };
    var roleOfPresence = function roleOfPresence(id) {
      return String((presence[id] || {}).role || '');
    };
    var connectedIds = Object.keys(presence).filter(function (id) {
      return /^screen:/.test(roleOfPresence(id)) && live(id);
    });
    connectedIds.forEach(function (id) {
      lastSeen.current[id] = now;
      if (!firstSeen.current[id]) firstSeen.current[id] = now;
    });
    var ids = connectedIds.concat(Object.keys(assigns).filter(function (id) {
      return !connectedIds.includes(id) && lastSeen.current[id] && now - lastSeen.current[id] < RECENT_MS;
    }));
    var screens = ids.map(function (id) {
      var a = assigns[id] || null;
      var requested = roleOfPresence(id).replace(/^screen:/, '');
      return {
        id: id,
        n: a && Number(a.n) >= 1 ? Number(a.n) : null,
        role: a && S.isRole(a.role) ? a.role : S.roleOf(requested),
        connected: connectedIds.includes(id),
        display: (presence[id] || {}).display || null,
        requested: requested
      };
    }).sort(function (a, b) {
      return (a.n || 999) - (b.n || 999) || (firstSeen.current[a.id] || 0) - (firstSeen.current[b.id] || 0);
    });
    var kindOf = function kindOf(id) {
      return roleOfPresence(id);
    };
    var others = Object.keys(presence).filter(function (id) {
      return live(id) && ['defib', 'vent'].includes(kindOf(id));
    }).map(function (id) {
      return {
        id: id,
        kind: kindOf(id)
      };
    });
    var legacy = Object.keys(presence).filter(function (id) {
      return live(id) && ['all', 'monitor', 'devices'].includes(kindOf(id));
    }).length;

    // Number every new screen, and untangle two connected screens that came back with the same
    // number (one dropped out and its number was given away): the one that arrived later moves.
    var sig = screens.map(function (s) {
      return "".concat(s.id, ":").concat(s.n, ":").concat(s.connected ? 1 : 0);
    }).join('|') + '#' + Object.keys(assigns).length;
    useEffect(function () {
      if (!on || !assignsLoaded) return;
      var code = sessionID;
      var used = new Set(screens.filter(function (s) {
        return s.n;
      }).map(function (s) {
        return s.n;
      }));
      var free = function free() {
        var n = 1;
        while (used.has(n)) n++;
        used.add(n);
        return n;
      };
      var byN = {};
      screens.filter(function (s) {
        return s.connected && s.n;
      }).forEach(function (s) {
        (byN[s.n] = byN[s.n] || []).push(s);
      });
      Object.keys(byN).forEach(function (k) {
        var list = byN[k];
        if (list.length < 2) return;
        list.sort(function (a, b) {
          return (firstSeen.current[a.id] || 0) - (firstSeen.current[b.id] || 0) || (Number((assigns[a.id] || {}).ts) || 0) - (Number((assigns[b.id] || {}).ts) || 0);
        });
        list.slice(1).forEach(function (s) {
          if (pending.current[s.id]) return;
          pending.current[s.id] = true;
          db.ref("sessions/".concat(code, "/screens/").concat(s.id)).update({
            n: free(),
            ts: Date.now()
          })["catch"](function (e) {
            return console.warn('Screen renumber failed', e);
          });
        });
      });
      screens.filter(function (s) {
        return s.connected && !assigns[s.id] && !pending.current[s.id];
      }).forEach(function (s) {
        pending.current[s.id] = true;
        db.ref("sessions/".concat(code, "/screens/").concat(s.id)).set({
          n: free(),
          role: S.isRole(s.requested) ? s.requested : 'all',
          ts: Date.now()
        })["catch"](function (e) {
          pending.current[s.id] = false;
          console.warn('Screen numbering failed', e);
        });
      });
    }, [on, assignsLoaded, sig]);
    var ref = function ref(id) {
      return window.db.ref("sessions/".concat(codeRef.current, "/screens/").concat(id));
    };
    var setRole = function setRole(id, role) {
      if (!window.db || !S.isRole(role) || !assigns[id]) return;
      ref(id).update({
        role: role
      })["catch"](function (e) {
        return console.warn('Screen change failed', e);
      });
    };
    var applyPreset = function applyPreset(preset) {
      screens.filter(function (s) {
        return s.connected && s.n && assigns[s.id];
      }).forEach(function (s, i) {
        return setRole(s.id, S.presetRole(preset, i));
      });
    };
    var forget = function forget(id) {
      if (!window.db) return;
      delete lastSeen.current[id];
      ref(id).remove()["catch"](function () {});
    };
    var showNumbers = function showNumbers(show) {
      if (!window.db || !codeRef.current) return;
      identifyRef.current = !!show;
      var r = window.db.ref("sessions/".concat(codeRef.current, "/screenIdentify"));
      if (show) {
        r.set(true)["catch"](function () {});
        try {
          r.onDisconnect().remove()["catch"](function () {});
        } catch (e) {}
      } else r.remove()["catch"](function () {});
    };
    return {
      ready: on,
      sessionID: sessionID,
      screens: screens,
      others: others,
      legacy: legacy,
      setRole: setRole,
      applyPreset: applyPreset,
      forget: forget,
      showNumbers: showNumbers
    };
  };

  // ---- On a patient screen: its number, what the controller chose for it, and whether to show
  // the number now.
  var useMyScreen = function useMyScreen(sessionID, id) {
    var _useState9 = useState(null),
      _useState0 = _slicedToArray(_useState9, 2),
      mine = _useState0[0],
      setMine = _useState0[1];
    var _useState1 = useState(false),
      _useState10 = _slicedToArray(_useState1, 2),
      identify = _useState10[0],
      setIdentify = _useState10[1];
    useEffect(function () {
      var db = window.db;
      if (!db || !sessionID || !id) return;
      var r1 = db.ref("sessions/".concat(sessionID, "/screens/").concat(id));
      var r2 = db.ref("sessions/".concat(sessionID, "/screenIdentify"));
      var on1 = function on1(snap) {
        return setMine(snap.val() || null);
      };
      var on2 = function on2(snap) {
        return setIdentify(snap.val() === true);
      };
      r1.on('value', on1, function () {});
      r2.on('value', on2, function () {});
      return function () {
        r1.off('value', on1);
        r2.off('value', on2);
        setMine(null);
        setIdentify(false);
      };
    }, [sessionID, id]);
    var S = window.SimScreens;
    return {
      n: mine && Number(mine.n) >= 1 ? Number(mine.n) : null,
      role: mine && S.isRole(mine.role) ? mine.role : null,
      identify: identify
    };
  };

  // The big number on a patient screen. It never takes a press: the screen underneath keeps working.
  var ScreenNumberOverlay = function ScreenNumberOverlay(_ref) {
    var n = _ref.n,
      role = _ref.role;
    var S = window.SimScreens;
    return /*#__PURE__*/React.createElement("div", {
      className: "absolute inset-0 z-[300] pointer-events-none flex items-center justify-center p-4",
      "data-testid": "screen-number",
      "aria-live": "polite"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col items-center gap-3 bg-black/75 border-4 border-white/80 rounded-3xl px-10 py-6 shadow-2xl animate-fadeIn"
    }, /*#__PURE__*/React.createElement("div", {
      className: "rounded-2xl px-10 font-black leading-none ".concat(S.numberColour(n)),
      style: {
        fontSize: 'min(38vh, 38vw)'
      }
    }, n || '?'), /*#__PURE__*/React.createElement("div", {
      className: "text-white text-2xl md:text-4xl font-bold text-center"
    }, n ? "Screen ".concat(n) : 'New screen'), /*#__PURE__*/React.createElement("div", {
      className: "text-slate-200 text-lg md:text-2xl text-center"
    }, S.ROLES[S.roleOf(role)]["short"])));
  };
  var qrSvg = function qrSvg(url) {
    try {
      var q = window.qrcode(0, 'M');
      q.addData(url);
      q.make();
      return q.createSvgTag({
        cellSize: 5,
        margin: 2,
        scalable: true
      }).replace('<svg ', '<svg style="width:100%;height:100%;display:block" role="img" aria-label="QR code to join as a patient screen" ');
    } catch (e) {
      return null;
    }
  };
  var DISPLAY = {
    'patient monitor': 'the monitor',
    'arrest view': 'the monitor (arrest view)',
    defib: 'the defib',
    ventilator: 'the ventilator'
  };

  // Which connected screens show each part. Used by the panel and by the live-sim warning.
  var coverage = function coverage(screens) {
    var S = window.SimScreens;
    var live = screens.filter(function (s) {
      return s.connected && s.n;
    });
    var out = {};
    S.PARTS.forEach(function (p) {
      out[p] = live.filter(function (s) {
        return S.partsOf(s.role).includes(p);
      }).map(function (s) {
        return s.n;
      });
    });
    return out;
  };

  // =========================================================================================
  // THE SCREENS PANEL (start screen, live sim, Defib Sim). Every screen shows its number while
  // it is open.
  // =========================================================================================
  var ScreensPanel = function ScreensPanel(_ref2) {
    var sessionID = _ref2.sessionID;
    var _window = window,
      Button = _window.Button,
      Lucide = _window.Lucide;
    var S = window.SimScreens;
    var link = useContext(ScreenLinkContext);
    var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      blocked = _useState12[0],
      setBlocked = _useState12[1];
    var ready = !!(link && link.ready);
    useEffect(function () {
      if (!ready) return;
      link.showNumbers(true);
      return function () {
        return link.showNumbers(false);
      };
    }, [ready, sessionID]);
    var url = S.screenUrl(sessionID);
    var site = (window.location.origin + window.location.pathname).replace(/^https?:\/\//, '').replace(/index\.html$/, '').replace(/\/$/, '');
    var screens = link ? link.screens : [];
    var connected = screens.filter(function (s) {
      return s.connected && s.n;
    });
    var presets = S.presetsFor(connected.length);
    var cover = coverage(screens);
    var missing = connected.length ? S.PARTS.filter(function (p) {
      return !cover[p].length;
    }) : [];
    var toggle = function toggle(s, part) {
      var parts = S.partsOf(s.role);
      var next = parts.includes(part) ? parts.filter(function (p) {
        return p !== part;
      }) : parts.concat([part]);
      var role = S.roleFromParts(next);
      if (role) link.setRole(s.id, role);
    };
    var openHere = function openHere() {
      setBlocked(!S.openScreenWindow(sessionID));
    };
    var svg = qrSvg(url);
    return /*#__PURE__*/React.createElement("div", {
      className: "space-y-4 text-left",
      "data-testid": "screens-panel"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col sm:flex-row gap-4 bg-slate-800/60 border border-slate-700 rounded-lg p-3"
    }, svg && /*#__PURE__*/React.createElement("div", {
      className: "bg-white p-1.5 rounded w-32 h-32 flex-none self-center",
      "data-testid": "screens-qr",
      title: url,
      dangerouslySetInnerHTML: {
        __html: svg
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "space-y-2 min-w-0"
    }, /*#__PURE__*/React.createElement("div", {
      className: "font-bold text-white"
    }, "Add a patient screen"), /*#__PURE__*/React.createElement("ol", {
      className: "text-xs text-slate-300 list-decimal pl-4 space-y-0.5"
    }, /*#__PURE__*/React.createElement("li", null, "On the tablet, laptop or TV, scan this code. Or go to ", /*#__PURE__*/React.createElement("b", {
      className: "font-mono text-slate-100 break-all"
    }, site), ", choose ", /*#__PURE__*/React.createElement("b", null, "Patient screen"), " and type ", /*#__PURE__*/React.createElement("b", {
      className: "font-mono text-white tracking-widest"
    }, sessionID), "."), /*#__PURE__*/React.createElement("li", null, "The screen shows a big number."), /*#__PURE__*/React.createElement("li", null, "Below, choose what each numbered screen shows. You can change it at any time.")), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap items-center gap-2"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "outline",
      onClick: openHere,
      className: "h-9 text-xs gap-1.5"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "external-link",
      className: "w-4 h-4"
    }), " Open a patient screen on this computer"), /*#__PURE__*/React.createElement("span", {
      className: "text-[11px] text-slate-400"
    }, "For a monitor, TV or projector plugged into this computer: drag the new window onto it and make it full screen (", /*#__PURE__*/React.createElement("kbd", {
      className: "font-mono"
    }, "F11"), ").")), blocked && /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-amber-300"
    }, "The browser blocked the new window. Allow pop-ups for this site, or ", /*#__PURE__*/React.createElement("a", {
      href: url,
      target: "_blank",
      rel: "noopener",
      className: "underline"
    }, "open it in a new tab"), " and drag the tab out into its own window."))), !ready && /*#__PURE__*/React.createElement("p", {
      className: "text-sm text-amber-300"
    }, "The live session is not connected, so screens cannot be listed. Check the internet connection."), ready && screens.length === 0 && /*#__PURE__*/React.createElement("div", {
      className: "text-center border-2 border-dashed border-slate-700 rounded-lg p-5 text-slate-400",
      "data-testid": "screens-empty"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "monitor",
      className: "w-8 h-8 mx-auto mb-2 text-slate-500"
    }), /*#__PURE__*/React.createElement("div", {
      className: "font-bold text-slate-300"
    }, "No patient screens yet"), /*#__PURE__*/React.createElement("div", {
      className: "text-xs mt-1"
    }, "Each one appears here, numbered, as soon as it joins.")), presets.length > 0 && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "text-[10px] uppercase font-bold text-slate-400 tracking-wider mb-1"
    }, "Quick set-up for ", connected.length, " screens"), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap gap-2"
    }, presets.map(function (p) {
      var active = connected.every(function (s, i) {
        return s.role === S.presetRole(p, i);
      });
      return /*#__PURE__*/React.createElement("button", {
        key: p.key,
        type: "button",
        "data-preset": p.key,
        "aria-pressed": active,
        onClick: function onClick() {
          return link.applyPreset(p);
        },
        className: "text-left rounded-lg border-2 px-3 py-2 flex flex-col gap-1 ".concat(active ? 'border-sky-400 bg-sky-950/40' : 'border-slate-600 bg-slate-800 hover:border-slate-400')
      }, /*#__PURE__*/React.createElement("span", {
        className: "text-xs font-bold text-white"
      }, p.label), /*#__PURE__*/React.createElement("span", {
        className: "flex flex-wrap gap-1"
      }, connected.map(function (s, i) {
        return /*#__PURE__*/React.createElement("span", {
          key: s.id,
          className: "flex items-center gap-1 text-[10px] text-slate-300"
        }, /*#__PURE__*/React.createElement("span", {
          className: "w-4 h-4 rounded text-[10px] font-black flex items-center justify-center ".concat(S.numberColour(s.n))
        }, s.n), S.ROLES[S.presetRole(p, i)]["short"]);
      })));
    }))), screens.length > 0 && /*#__PURE__*/React.createElement("ul", {
      className: "space-y-2",
      "aria-label": "Patient screens"
    }, screens.map(function (s) {
      var parts = S.partsOf(s.role);
      var label = s.n ? "Screen ".concat(s.n) : 'New screen';
      return /*#__PURE__*/React.createElement("li", {
        key: s.id,
        "data-testid": "screen-row-".concat(s.n || 'new'),
        className: "flex flex-wrap items-center gap-3 border rounded-lg p-3 ".concat(s.connected ? 'bg-slate-800 border-slate-600' : 'bg-slate-900 border-slate-700 opacity-70')
      }, /*#__PURE__*/React.createElement("div", {
        className: "w-14 h-14 rounded-xl flex-none flex items-center justify-center text-3xl font-black ".concat(S.numberColour(s.n)),
        "aria-hidden": "true"
      }, s.n || '…'), /*#__PURE__*/React.createElement("div", {
        className: "flex-1 min-w-[9rem]"
      }, /*#__PURE__*/React.createElement("div", {
        className: "font-bold text-white"
      }, label), /*#__PURE__*/React.createElement("div", {
        className: "text-xs text-slate-400"
      }, !s.n ? 'Numbering…' : s.connected ? /*#__PURE__*/React.createElement(React.Fragment, null, "Connected", s.display ? /*#__PURE__*/React.createElement(React.Fragment, null, ", showing ", DISPLAY[s.display] || s.display) : null) : 'Not connected. If it comes back it keeps its number.')), /*#__PURE__*/React.createElement("div", {
        role: "group",
        "aria-label": "What ".concat(label.toLowerCase(), " shows"),
        className: "flex gap-1"
      }, S.PARTS.map(function (p) {
        var isOn = parts.includes(p);
        var last = isOn && parts.length === 1;
        return /*#__PURE__*/React.createElement("button", {
          key: p,
          type: "button",
          "data-part": p,
          "aria-pressed": isOn,
          disabled: !s.n || last,
          onClick: function onClick() {
            return toggle(s, p);
          },
          title: last ? 'A screen has to show something: turn another one on first.' : "".concat(isOn ? 'Take the' : 'Show the', " ").concat(S.PART_LABELS[p].toLowerCase(), " ").concat(isOn ? 'off' : 'on', " ").concat(label.toLowerCase()),
          className: "min-h-[44px] px-3 rounded-lg border-2 flex items-center gap-1.5 text-sm font-bold focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400 ".concat(isOn ? 'bg-sky-700 border-sky-400 text-white' : 'bg-slate-900 border-slate-600 text-slate-300 hover:border-slate-400', " ").concat(last ? 'cursor-not-allowed' : '')
        }, /*#__PURE__*/React.createElement(Lucide, {
          icon: isOn ? 'check-square' : 'square',
          className: "w-4 h-4"
        }), /*#__PURE__*/React.createElement(Lucide, {
          icon: S.PART_ICONS[p],
          className: "w-4 h-4"
        }), " ", S.PART_LABELS[p]);
      })), !s.connected && /*#__PURE__*/React.createElement(Button, {
        variant: "outline",
        onClick: function onClick() {
          return link.forget(s.id);
        },
        className: "h-9 text-xs"
      }, "Remove"), /*#__PURE__*/React.createElement("p", {
        className: "w-full text-xs text-slate-400 leading-snug"
      }, S.ROLES[s.role].text));
    })), connected.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "space-y-1",
      "data-testid": "screens-coverage"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap gap-2 text-xs"
    }, S.PARTS.map(function (p) {
      return /*#__PURE__*/React.createElement("span", {
        key: p,
        "data-cover": p,
        className: "px-2 py-1 rounded border font-bold flex items-center gap-1 ".concat(cover[p].length ? 'border-emerald-700 bg-emerald-950/30 text-emerald-300' : 'border-amber-600 bg-amber-950/40 text-amber-300')
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: S.PART_ICONS[p],
        className: "w-3 h-3"
      }), " ", S.PART_LABELS[p], ": ", cover[p].length ? "screen ".concat(cover[p].join(', ')) : 'on no screen');
    })), missing.length > 0 && /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-amber-300"
    }, "If you bring in the ", missing.filter(function (p) {
      return p !== 'monitor';
    }).map(function (p) {
      return S.PART_LABELS[p].toLowerCase();
    }).join(' or the ') || 'monitor', ", no screen will show it. Turn it on for one of the screens above.")), link && link.others.length > 0 && /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-slate-400",
      "data-testid": "screens-others"
    }, "Also linked: ", link.others.map(function (o) {
      return o.kind === 'vent' ? 'a ventilator page' : 'a defib page';
    }).join(', '), ". A page opened from a defib or ventilator link always shows that device. To choose what it shows here, open it as a patient screen instead."), link && link.legacy > 0 && /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-amber-300"
    }, link.legacy === 1 ? 'A patient screen' : "".concat(link.legacy, " patient screens"), " from an older version ", link.legacy === 1 ? 'is' : 'are', " linked. Reload ", link.legacy === 1 ? 'it' : 'them', " to number ", link.legacy === 1 ? 'it' : 'them', " here."));
  };

  // A short line for the start screen: how many screens, and what each shows.
  var screensSummary = function screensSummary(link) {
    var S = window.SimScreens;
    var c = link ? link.screens.filter(function (s) {
      return s.connected && s.n;
    }) : [];
    if (!c.length) return null;
    return c.map(function (s) {
      return "".concat(s.n, ": ").concat(S.ROLES[s.role]["short"]);
    }).join(' · ');
  };

  // On the live controller: a device that has been brought in but is on no connected screen.
  var ScreenDeviceWarning = function ScreenDeviceWarning(_ref3) {
    var state = _ref3.state,
      onOpen = _ref3.onOpen;
    var _window2 = window,
      Lucide = _window2.Lucide;
    var link = useContext(ScreenLinkContext);
    if (!link || !link.ready) return null;
    var live = link.screens.filter(function (s) {
      return s.connected && s.n;
    });
    if (!live.length) return null;
    var cover = coverage(link.screens);
    var lost = [];
    // A defib or ventilator tablet linked on its own (link.others) counts as showing that device.
    var tablet = function tablet(kind) {
      return link.others.some(function (o) {
        return o.kind === kind;
      });
    };
    if (state.defibPanelOpen && !cover.defib.length && !tablet('defib')) lost.push('defib');
    if (state.ventPanelOpen && !cover.vent.length && !tablet('vent')) lost.push('ventilator');
    if (!lost.length) return null;
    // role="alert" on the button itself would hide that it is a button from screen readers.
    return /*#__PURE__*/React.createElement("span", {
      role: "status",
      className: "contents"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: onOpen,
      "data-testid": "screens-warning",
      className: "h-8 px-2 flex items-center gap-1 rounded border border-amber-500 bg-amber-950/60 text-amber-200 text-[10px] uppercase font-bold whitespace-nowrap"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "alert-triangle",
      className: "w-3 h-3"
    }), " ", lost.join(' and '), " on no screen"));
  };

  // =========================================================================================
  // "SCREENS SHOW: MONITOR | DEFIB | VENTILATOR", at the top of the live controller.
  // One press puts that view in front on every patient screen that has it (state.screenFront,
  // carried to the screens in the live defib object). Defib and Ventilator bring the device in
  // first if it is not in the room yet. Monitor only changes what is in front: a defib or
  // ventilator already in the room stays loaded behind it (the ventilator keeps ventilating),
  // and the small x beside a device takes it away. Beside the buttons (wide screens), what each
  // numbered screen reports it is showing now. It sits in the "Patient now" strip's top line
  // (PatientStatusPanel's `extra`), so it costs the controller no extra height on a laptop.
  // =========================================================================================
  var SHOW_LABELS = {
    monitor: 'Monitor',
    defib: 'Defib',
    vent: 'Ventilator'
  };
  var SHOW_ICONS = {
    monitor: 'activity',
    defib: 'zap',
    vent: 'wind'
  };
  var SHOW_TONES = {
    monitor: {
      on: 'bg-sky-700 border-sky-300 text-white',
      off: 'bg-slate-900 border-sky-700/70 text-sky-300 hover:border-sky-400'
    },
    defib: {
      on: 'bg-amber-500 border-amber-200 text-black',
      off: 'bg-slate-900 border-amber-600/70 text-amber-300 hover:border-amber-400'
    },
    vent: {
      on: 'bg-cyan-500 border-cyan-200 text-black',
      off: 'bg-slate-900 border-cyan-700/70 text-cyan-300 hover:border-cyan-400'
    }
  };
  var SHOWING = {
    'patient monitor': 'Monitor',
    'arrest view': 'Monitor',
    defib: 'Defib',
    ventilator: 'Ventilator'
  };

  // What the screens have in front, as far as the controller knows: the last request, if the
  // device it names is still in the room, else the device most recently brought in, else the monitor.
  var frontViewOf = function frontViewOf(state) {
    var open = {
      monitor: true,
      defib: !!state.defibPanelOpen,
      vent: !!state.ventPanelOpen
    };
    var f = state.screenFront;
    if (f && open[f.view]) return f.view;
    return open.defib ? 'defib' : open.vent ? 'vent' : 'monitor';
  };
  var PatientScreenSwitch = function PatientScreenSwitch(_ref4) {
    var sim = _ref4.sim,
      addLogEntry = _ref4.addLogEntry,
      _ref4$showVent = _ref4.showVent,
      showVent = _ref4$showVent === void 0 ? true : _ref4$showVent,
      onOpenScreens = _ref4.onOpenScreens;
    var _window3 = window,
      Lucide = _window3.Lucide;
    var link = useContext(ScreenLinkContext);
    var state = sim.state;
    var log = addLogEntry || sim.addLogEntry || function () {};
    var views = showVent ? ['monitor', 'defib', 'vent'] : ['monitor', 'defib'];
    var inRoom = {
      monitor: true,
      defib: !!state.defibPanelOpen,
      vent: !!state.ventPanelOpen
    };
    var front = frontViewOf(state);
    var live = link && link.ready ? link.screens.filter(function (s) {
      return s.connected && s.n;
    }) : [];
    var cover = coverage(live);
    // A device tablet linked on its own (not a numbered screen) shows its device as well.
    var tablet = function tablet(k) {
      return !!(link && link.others.some(function (o) {
        return o.kind === k;
      }));
    };
    var ventilating = Object.values(state.ventMirror || {}).some(function (m) {
      return m && m.state === 'ventilating';
    });
    var show = function show(view) {
      if (view === 'defib' && !inRoom.defib) sim.dispatch({
        type: 'SET_DEFIB_PANEL',
        payload: true
      });
      if (view === 'vent' && !inRoom.vent) sim.dispatch({
        type: 'SET_VENT_PANEL',
        payload: true
      });
      sim.dispatch({
        type: 'SET_SCREEN_FRONT',
        payload: view
      });
      if (view !== front) log("Patient screens switched to the ".concat(view === 'vent' ? 'ventilator' : view, " (facilitator)"), 'system');
    };
    var takeAway = function takeAway(view) {
      if (view === 'vent' && ventilating && !window.confirm('Take the ventilator away? It closes on every patient screen, so the patient stops being ventilated.')) return;
      sim.dispatch({
        type: view === 'defib' ? 'SET_DEFIB_PANEL' : 'SET_VENT_PANEL',
        payload: false
      });
      log("".concat(view === 'defib' ? 'Defib' : 'Ventilator', " taken off the patient screens (facilitator)"), 'system');
    };
    // The chosen view is on no connected screen (and no tablet), so nobody would see it.
    var unseen = live.length > 0 && !cover[front].length && !(front !== 'monitor' && tablet(front));
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap items-center gap-x-2 gap-y-1 min-w-0",
      "data-testid": "screen-show-switch"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-[9px] uppercase font-bold text-slate-300 tracking-wider flex items-center gap-1 whitespace-nowrap"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "monitor",
      className: "w-3.5 h-3.5"
    }), " ", /*#__PURE__*/React.createElement("span", {
      className: "max-sm:hidden"
    }, "Screens show"), /*#__PURE__*/React.createElement("span", {
      className: "sm:hidden"
    }, "Show")), /*#__PURE__*/React.createElement("div", {
      role: "group",
      "aria-label": "What the patient screens show",
      className: "flex gap-1"
    }, views.map(function (v) {
      var on = front === v;
      var name = v === 'vent' ? 'ventilator' : v;
      return /*#__PURE__*/React.createElement("span", {
        key: v,
        className: "inline-flex"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        "data-show": v,
        "aria-pressed": on,
        onClick: function onClick() {
          return show(v);
        },
        "aria-label": "".concat(SHOW_LABELS[v], " on the patient screens"),
        title: v === 'monitor' ? 'Put the monitor in front on the patient screens. A defib or ventilator already in the room stays ready behind it.' : "Bring the ".concat(name, " in").concat(inRoom[v] ? '' : ' (if it is not already)', " and put it in front on the patient screens."),
        className: "h-8 px-2.5 border-2 flex items-center gap-1 text-xs font-bold whitespace-nowrap focus:outline-none focus-visible:ring-2 focus-visible:ring-white ".concat(v !== 'monitor' && inRoom[v] ? 'rounded-l-lg' : 'rounded-lg', " ").concat(on ? SHOW_TONES[v].on : SHOW_TONES[v].off)
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: SHOW_ICONS[v],
        className: "w-4 h-4"
      }), " ", v === 'vent' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: "max-sm:hidden"
      }, SHOW_LABELS[v]), /*#__PURE__*/React.createElement("span", {
        className: "sm:hidden"
      }, "Vent")) : SHOW_LABELS[v]), v !== 'monitor' && inRoom[v] && /*#__PURE__*/React.createElement("button", {
        type: "button",
        "data-take-away": v,
        onClick: function onClick() {
          return takeAway(v);
        },
        "aria-label": "Take the ".concat(name, " away"),
        title: "Take the ".concat(name, " away: it closes on every patient screen."),
        className: "h-8 px-1 border-2 border-l-0 rounded-r-lg flex items-center ".concat(on ? SHOW_TONES[v].on : SHOW_TONES[v].off)
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: "x",
        className: "w-3.5 h-3.5"
      })));
    })), /*#__PURE__*/React.createElement("div", {
      className: "max-xl:hidden flex flex-wrap items-center gap-1.5 text-[11px] text-slate-300 min-w-0",
      "data-testid": "screen-show-now"
    }, link && link.ready && live.length === 0 && /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: onOpenScreens,
      className: "underline text-slate-400 hover:text-white whitespace-nowrap"
    }, "No patient screen yet"), live.map(function (s) {
      return /*#__PURE__*/React.createElement("span", {
        key: s.id,
        className: "flex items-center gap-1 whitespace-nowrap",
        "data-screen-now": s.n
      }, /*#__PURE__*/React.createElement("span", {
        className: "w-5 h-5 rounded text-[11px] font-black flex items-center justify-center ".concat(window.SimScreens.numberColour(s.n))
      }, s.n), SHOWING[s.display] || window.SimScreens.ROLES[s.role]["short"]);
    })), unseen && /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: onOpenScreens,
      "data-testid": "screen-show-unseen",
      title: "Open Screens and turn it on for one of the patient screens.",
      className: "h-8 px-2 flex items-center gap-1 rounded border border-amber-500 bg-amber-950/60 text-amber-200 text-[10px] uppercase font-bold whitespace-nowrap"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "alert-triangle",
      className: "w-3 h-3"
    }), " No screen is set to show the ", front === 'vent' ? 'ventilator' : front));
  };
  Object.assign(window, {
    ScreenLinkContext: ScreenLinkContext,
    useScreenLinkController: useScreenLinkController,
    useMyScreen: useMyScreen,
    ScreenNumberOverlay: ScreenNumberOverlay,
    ScreensPanel: ScreensPanel,
    ScreenDeviceWarning: ScreenDeviceWarning,
    screensSummary: screensSummary,
    PatientScreenSwitch: PatientScreenSwitch
  });
})();